import { Button, Flex, Grid, GridItem, Heading, Highlight, HStack, Image, VStack } from "@chakra-ui/react"

import { FaAngleDown, FaArrowRightLong } from "react-icons/fa6";

import './styles/MainComponent.css';
import './styles/styles.css';

function MainComponent(props: any) {

  return (
    <div>
        {/* Desktop view only */}
        <Flex className="main_component__parent" direction='column'>
            <Flex direction='column' gap='6' style={{marginTop: "25px"}}>
                <Flex direction='column' gap='6'>
                    <Flex direction='column' gap='1'>
                        <Heading color='black' fontWeight='bold' size='7xl' textAlign='center'>
                            <Highlight query='Negotiator.' styles={{color: "#FB5383"}}>
                                Expert Negotiator.
                            </Highlight>
                        </Heading>
                        <Heading color='black' fontWeight='bold' size='6xl' textAlign='center' style={{marginTop: '10px'}}>
                            In your back pocket
                        </Heading>
                    </Flex>
                    <Heading color='gray' textAlign='center'>
                        Have an offer? Work with a personalized coach to maximize your salary potential.
                    </Heading>
                </Flex>
                <Flex gap='4' justifyContent='center'>
                    <Button backgroundColor='#FB5383' color='white' className='button' fontWeight='bold' rounded='md' size='lg' onMouseDown={() => {
                        window.location.href='#contactus'
                    }}>
                        Increase your Offer <FaArrowRightLong style={{height: "15px", width: "15px"}} />
                    </Button>
                    <Button border='1px solid #FB5383' className='button' color='#FB5383' rounded='md' size='lg' variant='outline' onMouseDown={() => {
                        window.location.href='#testimonials'
                    }}>
                        See Testimonials <FaAngleDown style={{height: "15px", width: "15px"}}/>
                    </Button>
                </Flex>
            </Flex>
        </Flex>

        {/* Mobile only view */}
        <Flex className="main_component__mobile_parent" direction='column'>
            <Flex direction='column' gap='6' style={{marginTop: "20px"}}>
                <Flex direction='column' gap='6'>
                    <Flex direction='column' gap='1'>
                        <Heading color='black' fontWeight='bold' size='6xl' textAlign='center'>
                            <Highlight query='Negotiator.' styles={{color: "#FB5383"}}>
                                Expert Negotiator.
                            </Highlight>
                        </Heading>
                        <Heading color='black' fontWeight='bold' size='4xl' textAlign='center'>
                            In your back pocket
                        </Heading>
                    </Flex>
                    <Heading color='gray' textAlign='center' size='md'>
                        Have an offer? Work with a personalized coach to maximize your salary potential.
                    </Heading>
                </Flex>
                <Flex gap='4' direction='column' justifyContent='center' style={{marginTop: '10px'}}>
                    <Button backgroundColor='#FB5383' color='white' className='button' fontWeight='bold' rounded='md' size='lg' onMouseDown={() => {
                        window.location.href='#contactus'
                    }}>
                        Increase your Offer <FaArrowRightLong style={{height: "15px", width: "15px"}} />
                    </Button>
                    <Button border='1px solid #FB5383' className='button' color='#FB5383' rounded='md' size='lg' variant='outline' onMouseDown={() => {
                        window.location.href='#testimonials'
                    }}>
                        See Testimonials <FaAngleDown style={{height: "15px", width: "15px"}}/>
                    </Button>
                </Flex>
            </Flex>
        </Flex>
    </div>
  );
}

export default MainComponent;
